export const SELECT_TESTS_PROMPT = 'Select one or more tests to update the labels';
